import { lazy, Suspense } from "react";

/* Lexical 렌더러(markdown-lexical.tsx)의 lazy 셸 — 이 앱은 라우트 코드 스플리팅이
 * 없어서 이 lazy()가 Lexical을 엔트리 청크 밖으로 격리하는 유일한 장치다.
 * 폴백은 보이지 않는 스페이서 (헤더/제목은 이미 위에서 렌더된 상태). */

const MarkdownLexical = lazy(() => import("./markdown-lexical"));

type MarkdownProps = {
	children: string;
	className?: string;
};

export function Markdown({ children, className }: MarkdownProps) {
	return (
		<Suspense fallback={<div className="min-h-[40vh]" aria-busy="true" />}>
			<MarkdownLexical className={className}>{children}</MarkdownLexical>
		</Suspense>
	);
}
